import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import NotificationTest from '../../components/NotificationTest';
import { useAuth } from '../../contexts/AuthContext';
import { db } from '../../services/firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';

const AdminNotificationTestPage = () => {
  const { currentUser } = useAuth();
  const [adminStatus, setAdminStatus] = useState({ isAdmin: false, checking: true });
  const [userDetails, setUserDetails] = useState(null);

  // Verificar si el usuario actual tiene rol admin
  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!currentUser) {
        setAdminStatus({ isAdmin: false, checking: false });
        return;
      }

      try {
        const userRef = doc(db, 'users', currentUser.uid);
        const userDoc = await getDoc(userRef);
        
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setUserDetails(userData);
          
          const isAdmin = userData.role === 'admin' || userData.isAdmin === true;
          setAdminStatus({ isAdmin, checking: false });
          
          console.log('👤 Datos del usuario:', userData);
          console.log('🔑 ¿Tiene rol admin?', isAdmin);
        } else {
          setAdminStatus({ isAdmin: false, checking: false });
        }
      } catch (error) {
        console.error('❌ Error verificando rol admin:', error);
        setAdminStatus({ isAdmin: false, checking: false, error: error.message });
      }
    };
    
    checkAdminStatus();
  }, [currentUser]);

  // Función para configurar el usuario con rol admin
  const setAsAdmin = async () => {
    if (!currentUser) return;
    
    try {
      const userRef = doc(db, 'users', currentUser.uid);
      await updateDoc(userRef, {
        role: 'admin',
        isAdmin: true,
        updatedAt: new Date()
      });
      
      alert('¡Usuario configurado con rol admin! Recarga la página para ver los cambios.');
      window.location.reload();
    } catch (error) {
      console.error('❌ Error configurando rol admin:', error);
      alert('Error: ' + error.message);
    }
  };

  return (
    <Layout>
      <div style={{ padding: '20px' }}>
        <h1>Prueba de Notificaciones</h1>
        
        {adminStatus.checking ? (
          <div>Verificando estado de administrador...</div>
        ) : (
          <>
            <div style={{ 
              padding: '15px', 
              backgroundColor: adminStatus.isAdmin ? '#d1e7dd' : '#f8d7da',
              color: adminStatus.isAdmin ? '#0f5132' : '#842029',
              borderRadius: '8px',
              marginBottom: '20px'
            }}>
              <h3 style={{ margin: '0 0 10px 0' }}>
                Estado de Usuario: {adminStatus.isAdmin ? 'Rol Admin ✅' : 'No tiene rol Admin ❌'}
              </h3>
              
              {userDetails && (
                <div style={{ marginBottom: '15px' }}>
                  <div><strong>ID:</strong> {currentUser.uid}</div>
                  <div><strong>Email:</strong> {currentUser.email}</div>
                  <div><strong>Nombre:</strong> {userDetails.displayName || 'No especificado'}</div>
                  <div><strong>Rol:</strong> {userDetails.role || 'No especificado'}</div>
                  <div><strong>isAdmin:</strong> {userDetails.isAdmin ? 'true' : 'false'}</div>
                </div>
              )}
              
              {!adminStatus.isAdmin && (
                <button
                  onClick={setAsAdmin}
                  style={{
                    padding: '10px 15px',
                    backgroundColor: '#0d6efd',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontWeight: 'bold'
                  }}
                >
                  Configurar con Rol Admin
                </button>
              )}
            </div>
            
            <NotificationTest />
            
            <div style={{ marginTop: '30px', padding: '20px', backgroundColor: '#fff3cd', borderRadius: '8px' }}>
              <h3>Instrucciones para Solucionar Problemas de Notificaciones</h3>
              
              <ol style={{ paddingLeft: '20px' }}>
                <li>Asegúrate de que tu usuario tenga rol admin (role="admin" o isAdmin=true)</li>
                <li>Verifica que la variable REACT_APP_FALLBACK_ADMIN_UID esté configurada en el archivo .env</li>
                <li>Abre la consola del navegador (F12) y ejecuta: <code>fixAdminRole("TU_ID_DE_USUARIO")</code></li>
                <li>Reinicia la aplicación después de hacer cambios</li>
                <li>Prueba a crear una notificación usando los botones de arriba</li>
              </ol>
              
              <p><strong>Nota:</strong> Si sigues teniendo problemas, contacta al equipo de desarrollo.</p>
            </div>
          </>
        )}
      </div>
    </Layout>
  );
};

export default AdminNotificationTestPage;
